import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

interface ICheckListItem {
  id?: string,
  name: string,
  itemKey: string,
  icon: string,
  url?: string,
  link?: string,
  isChecked: boolean,
  hasCheckbox?: boolean,

  toggleCheckbox(key: string, id: string | null): any,

  logLinkClick(key: string): any,
}

export const ChecklistItem = ({
                                id,
                                name,
                                itemKey,
                                icon,
                                link,
                                url,
                                isChecked,
                                toggleCheckbox,
                                logLinkClick,
                                hasCheckbox = true
                              }: ICheckListItem) => {
  const handleChange = () => {
    if (itemKey === 'travel_insurance') {
      return;
    }
    return toggleCheckbox(itemKey, id)
  }

  const handleLinkClick = () => {
    logLinkClick(itemKey)
  }

  const renderIcon = () => {
    if (itemKey === 'travel_insurance') {
      return (
        <img src={require(`../../../../Shell/Img/admiral_logo.png`)} alt={itemKey + ' icon'}
             className={'checklist-admiral-icon'}/>
      )
    }

    return (
      <div style={{ marginLeft: '35px' }}>
        <img src={require(`../images/${icon}`)} alt={itemKey + ' icon'} className={'checklist-icon'}/>
      </div>
    )
  }

  return (
    <Row className={'holiday-checklist-item'}>
      <Col xs={12} sm={2}>
        {renderIcon()}
      </Col>
      <Col xs={10} sm={4}>
        <label htmlFor={itemKey} style={{ paddingLeft: 10 }} className={itemKey === 'fcdo' ? 'fcdo-mobile' : ''}>
          {name}
        </label>
      </Col>
      <Col xs={2} sm={2} className={'checkbox'}>
        {hasCheckbox &&
          <label>
            <input type="checkbox"
                   id={itemKey}
                   checked={isChecked || itemKey === 'travel_insurance'}
                   onChange={handleChange}
            />
            <div/>
          </label>
        }
      </Col>
      <Col xs={12} sm={4}>
        {url && link &&
          <a href={url} target={'_blank'} onClick={handleLinkClick}>{link}</a>
        }
      </Col>
    </Row>
  )
}
